import React, { FunctionComponent } from "react";

type Props = {};

export const FormSkeleton: FunctionComponent<Props> = ({}) => {
  return (
    <div className="mb-8 flex w-full animate-pulse flex-col gap-5 rounded-md p-2">
      <div className="grid w-full grid-cols-2 gap-5">
        <div className="col-span-2 flex flex-col gap-2 md:col-span-1">
          <div className="h-5 w-28 rounded-md bg-gray-200" />
          <div className="h-12 w-full rounded-md bg-gray-200" />
        </div>
        <div className="col-span-1 hidden flex-col gap-2 md:flex">
          <div className="h-5 w-28 rounded-md bg-gray-200" />
          <div className="h-12 w-full rounded-md bg-gray-200" />
        </div>
      </div>
      <div className="w-full gap-2">
        <div className="flex flex-col gap-2">
          <div className="h-5 w-28 rounded-md bg-gray-200" />
          <div className="h-12 w-full rounded-md bg-gray-200" />
        </div>
      </div>
      <div className="w-full gap-2">
        <div className="flex flex-col gap-2">
          <div className="h-5 w-28 rounded-md bg-gray-200" />
          <div className="h-12 w-full rounded-md bg-gray-200" />
        </div>
      </div>
      <div className="w-full gap-2">
        <div className="flex flex-col gap-2">
          <div className="h-5 w-28 rounded-md bg-gray-200" />
          <div className="h-12 w-full rounded-md bg-gray-200" />
        </div>
      </div>
    </div>
  );
};
